import cx from "classnames";
import React from "react";

type Props = Readonly<{
  id: string;
  selected: boolean;
}>;

const NULL_CELL: React.CSSProperties = {
  bottom: 0,
  left: 0,
  pointerEvents: "none",
  right: 0,
  top: 0,
  zIndex: 1199,
};

const NullCellZoneComponent = ({ id, selected }: Props) => {
  return (
    <div className={cx("zone", "zone-cell", { selected })} id={`zone-${id}`} style={NULL_CELL} />
  );
};
NullCellZoneComponent.displayName = "NullCellZone";
export const NullCellZone = React.memo(NullCellZoneComponent);
